import { ErrorMessage, Text } from '@wyz/ui';
import { NoActions } from '~/common/components';
import { Trans } from '~/common/context';
import { usePurchaseContext } from '~/purchase/context';

export default function ContainerCustomerProtected({
  component: Component,
}: {
  component: React.ComponentType;
}) {
  const { state } = usePurchaseContext();

  if (state.targetCustomer) {
    return <Component />;
  }
  return (
    <>
      <ErrorMessage
        message={
          <Text heading='normal' color='danger'>
            <Trans
              i18nKey={
                'app.purchase.search_page.errors.required_customer.alert'
              }
              components={[<strong key={0} />]}
            />
          </Text>
        }
      />
      <div>
        <NoActions
          title={
            <Trans i18nKey='app.purchase.search_page.errors.required_customer.title' />
          }
          subtitle={
            <Trans
              i18nKey={
                'app.purchase.search_page.errors.required_customer.subtitle'
              }
            />
          }
        />
      </div>
    </>
  );
}
